require('./bootstrap')

import Vue from 'vue'
window.Vue = require('vue')

import VueRouter from 'vue-router'
Vue.use(VueRouter)
import router from './router'
Vue.router = router

import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = `${process.env.MIX_APP_URL}`

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
Vue.use(VueSweetalert2)

import { abilitiesPlugin } from '@casl/vue'
import ability from './services/ability'
// import auth from './store/auth'
// console.log(auth.getters.ab)
Vue.use(abilitiesPlugin, ability)
import { Can } from '@casl/vue'
Vue.component('Can', Can)

Vue.use(require('vue-moment'))

import '@fortawesome/fontawesome-free/css/all.css'

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from 'vee-validate'
import en from 'vee-validate/dist/locale/en.json'
import * as rules from 'vee-validate/dist/rules'

extend('decimal', {
	validate: (value, { decimals = '*', separator = '.' } = {}) => {
	    if (value === null || value === undefined || value === '') {
	     	return {
	        	valid: false
	      	}
	    }

	    if (Number(decimals) === 0) {
	    	return {
	        	valid: /^-?\d*$/.test(value)
	      	}
	    }

	    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`
	    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`)

	    return {
		    valid: regex.test(value)
	    }
  	},

  	message: 'The {_field_} field must contain only decimal values'
})

extend('url', {
	validate: (value) => {
	    if (value === null || value === undefined || value === '') {
	    	return {
	    		valid: false
	    	}
	    }

		return {
			valid: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value)
		}

	},

	message: 'This value must be a valid URL'
})

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
});

localize('en', en);

import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

import InstantSearch from 'vue-instantsearch'
Vue.use(InstantSearch)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import Print from 'vue-print-nb'
Vue.use(Print)

// import index from './Index'
import store from './store'
import common from './mixins/common'
import mapGetters from './mixins/mapGetters'
Vue.mixin(common)
Vue.mixin(mapGetters)

/** Components */
Vue.component('index', require('./Index').default)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

Vue.directive('focus', {
	// When the bound element is inserted into the DOM...
	inserted: function (el) {
		// Focus the element
		el.focus()
	}
})

/** Instance */
store.dispatch('auth/me').then(() => {
	axios.get('/api/user/permissions').then((response) => {
	    store.dispatch('auth/setAbility', response.data)

        initializeVue()
	}).catch((err) => {
		initializeVue()
	})
})

function initializeVue() {
	const app = new Vue({
	    el: '#app',
	    router,
	    store,
	})
}
